var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-modal-card",
    { staticClass: "sc-modal-tags__border" },
    [
      _c("template", { attrs: { slot: "title" }, slot: "title" }, [
        _c("h2", { staticClass: "modal-card-title" }, [
          _vm._v("\n      Nova tag Xml\n    ")
        ])
      ]),
      _vm._v(" "),
      _c(
        "template",
        { attrs: { slot: "body" }, slot: "body" },
        [
          _c("sc-form", {
            ref: "form",
            attrs: { hasStyle: false, form: _vm.tag, rules: _vm.rules },
            on: { submit: _vm.saveTag },
            scopedSlots: _vm._u([
              {
                key: "fields",
                fn: function(ref) {
                  var fields = ref.fields
                  return [
                    _c(
                      "div",
                      { staticClass: "column" },
                      [
                        _c(
                          "sc-field",
                          {
                            attrs: {
                              label: "Nome Intelipost",
                              prop: "tms_name"
                            }
                          },
                          [
                            _c(
                              "sc-select",
                              {
                                attrs: { expanded: "" },
                                model: {
                                  value: fields.tms_name,
                                  callback: function($$v) {
                                    _vm.$set(fields, "tms_name", $$v)
                                  },
                                  expression: "fields.tms_name"
                                }
                              },
                              [
                                _c(
                                  "option",
                                  {
                                    attrs: { selected: "" },
                                    domProps: { value: null }
                                  },
                                  [_vm._v("Selecione")]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.enumTmsName, function(value) {
                                  return _c(
                                    "option",
                                    {
                                      key: value.name,
                                      domProps: { value: value.name }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(value.name) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "column", attrs: { expanded: "" } },
                      [
                        _c(
                          "sc-field",
                          {
                            attrs: {
                              label: "Nome Transportadora",
                              prop: "logistic_provider_name"
                            }
                          },
                          [
                            _c("sc-input", {
                              attrs: {
                                placeholder:
                                  "Nome da taxa usado pela transportadora"
                              },
                              model: {
                                value: fields.logistic_provider_name,
                                callback: function($$v) {
                                  _vm.$set(
                                    fields,
                                    "logistic_provider_name",
                                    $$v
                                  )
                                },
                                expression: "fields.logistic_provider_name"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "column" },
                      [
                        _c(
                          "sc-field",
                          {
                            attrs: {
                              label: "Tag de nomenclatura",
                              prop: "tag_name"
                            }
                          },
                          [
                            _c("sc-input", {
                              attrs: {
                                placeholder: "Digite a tag xml de nomenclatura"
                              },
                              model: {
                                value: fields.tag_name,
                                callback: function($$v) {
                                  _vm.$set(fields, "tag_name", $$v)
                                },
                                expression: "fields.tag_name"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "column" },
                      [
                        _c(
                          "sc-field",
                          {
                            attrs: { label: "Tag de valor", prop: "tag_value" }
                          },
                          [
                            _c("sc-input", {
                              attrs: { placeholder: "Digite tag xml de valor" },
                              model: {
                                value: fields.tag_value,
                                callback: function($$v) {
                                  _vm.$set(fields, "tag_value", $$v)
                                },
                                expression: "fields.tag_value"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              },
              {
                key: "actions",
                fn: function(ref) {
                  var isValid = ref.isValid
                  return [
                    _c(
                      "sc-field",
                      [
                        _c("sc-button", {
                          attrs: { text: "Cancelar" },
                          on: { click: _vm.closeModal }
                        }),
                        _vm._v(" "),
                        _c("sc-button", {
                          attrs: {
                            type: "submit",
                            theme: "primary",
                            text: "Salvar",
                            loading: _vm.loading,
                            disabled: !isValid
                          },
                          on: { click: _vm.closeModal }
                        })
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-936602d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-936602d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/xml-cte-tags/components/sc-modal-tag/ScModalTag.vue
// module id = null
// module chunks = 